import { render, staticRenderFns } from "./CalendarIcon.vue?vue&type=template&id=1026e320&scoped=true"
var script = {}
import style0 from "./CalendarIcon.vue?vue&type=style&index=0&id=1026e320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1026e320",
  null
  
)

export default component.exports